import { omit } from 'lodash-es';

import { MuxConfigurationResponse, MuxOrigin, MuxProductType, MuxRuleMatch } from '../datasource/generated';
import logger from './logger';

interface MuxConfigurationContext {
    origin: MuxOrigin;
    productType: MuxProductType;
}

export function parseMuxConfiguration(
    muxConfig: Pick<MuxConfigurationResponse, 'isEnabled' | 'envKey' | 'rules'> | undefined,
    { origin, productType }: MuxConfigurationContext,
): Pick<MuxConfigurationResponse, 'isEnabled' | 'envKey'> {
    if (!muxConfig) return { isEnabled: false, envKey: null };

    const { rules } = muxConfig;
    const config = omit(muxConfig, 'rules');

    for (const { match, ...rule } of rules ?? []) {
        if (match && ruleMatches(match)) {
            logger.log('Mux Rule matched', {
                rule,
                match,
                context: { origin, productType },
            });
            return {
                ...config,
                isEnabled: rule.isEnabled ?? config.isEnabled,
            };
        }
    }
    logger.log('Mux default config applied', { config });

    return config;

    function ruleMatches(match: MuxRuleMatch): boolean {
        if (match.origins && !match.origins?.includes(origin)) return false;
        if (match.productTypes && !match.productTypes?.includes(productType))
            return false;

        return true;
    }
}
